export const paymentStatuses = [
  { name: "Draft", value: "DRAFT" },
  { name: "Awaiting payment", value: "AWAITING_PAYMENT" },
  { name: "Paid", value: "PAID" }
];

export const documentTypes: {
  [key: string]: string;
} = {
  BILL: "Bill",
  CREDIT_NOTE: "Credit Note",
  RECEIPT: "Receipt"
  // INVOICE: "Invoice",
  // PURCHASE_ORDER: "Purchase Order",
  // STATEMENT_OF_ACCOUNT: "Statement of Account",
  // EXPENSE_CLAIM: "Expense Claim",
};

export const EMAIL_FORWARDING_SENDER_REASON_OPTIONS = [
  {
    value: "Phishing/Fraudulent Activity",
    label: "Phishing/Fraudulent Activity"
  },
  { value: "Malware/Virus Distribution", label: "Malware/Virus Distribution" },
  { value: "Unauthorised System Access", label: "Unauthorised System Access" },
  { value: "Spam/Irrelevant Emails", label: "Spam/Irrelevant Emails" },
  { value: "Data Privacy Violation", label: "Data Privacy Violation" },
  {
    value: "Security Threat/Compromised Account",
    label: "Security Threat/Compromised Account"
  },
  {
    value: "Legal/Regulatory Requirement",
    label: "Legal/Regulatory Requirement"
  },
  { value: "Breach of Contract", label: "Breach of Contract" },
  {
    value: "Termination of Business Relationship",
    label: "Termination of Business Relationship"
  },
  { value: "Other", label: "Other" }
];
